import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-plugin-react-i18next';
import linkedinIcon from '@icons/linkedinIcon';
import twitterIcon from '@icons/twitterIcon';
import * as styles from './style.module.scss';
const {
  postAuthor__head,
  postAuthor__image,
  postAuthor__info,
  postAuthor__socials,
  postAuthor__links,
  postAuthor__icon,
  postAuthor__socialsDesk,
  postAuthor__desk,
  postAuthor__headSimple,
  postAuthor__imageSimple,
  postAuthor__infoSimple,
  postAuthor__socialsSimple,
} = styles;

const PostAuthorHead = ({ author, theme = 'default' }) => {
  const img = getImage(author.profilePicture);
  const isSimple = theme === 'simple';

  const headClassName = `${postAuthor__head} ${
    isSimple ? postAuthor__headSimple : ''
  }`;
  const imageClassName = `${postAuthor__image} ${
    isSimple ? postAuthor__imageSimple : ''
  }`;
  const infoClassName = `${postAuthor__info} ${
    isSimple ? postAuthor__infoSimple : ''
  }`;
  const socialsClassName = `${postAuthor__socials} ${
    isSimple ? postAuthor__socialsSimple : ''
  }`;

  return (
    <div className={headClassName}>
      {!isSimple && (
        <GatsbyImage
          quality={100}
          className={imageClassName}
          image={img}
          alt={author.profilePicture.title}
        />
      )}
      <div className={infoClassName}>
        <div className={socialsClassName}>
          <div className={postAuthor__socialsDesk}>
            <h5>
              {isSimple && <span>By </span>}
              <Link to={`/blog/author/${author.slug}`}>{author.fullName}</Link>
            </h5>
            {!isSimple && (
              <div className={`${postAuthor__desk}`}>
                {author.linkedIn && (
                  <a
                    className={postAuthor__icon}
                    href={author.linkedIn}
                    target="_blank"
                    rel="nofollow noreferrer"
                  >
                    {linkedinIcon}
                  </a>
                )}
                {author.twitter && (
                  <a
                    className={postAuthor__icon}
                    href={author.twitter}
                    target="_blank"
                    rel="nofollow noreferrer"
                  >
                    {twitterIcon}
                  </a>
                )}
              </div>
            )}
          </div>
          {!isSimple && <p>{author.role}</p>}
        </div>
        {!isSimple && (
          <div className={postAuthor__links}>
            <a
              className={postAuthor__icon}
              href={author.linkedIn}
              target="_blank"
              rel="nofollow noreferrer"
            >
              {linkedinIcon}
            </a>
            {author.twitter && (
              <a
                className={postAuthor__icon}
                href={author.twitter}
                target="_blank"
                rel="nofollow noreferrer"
              >
                {twitterIcon}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PostAuthorHead;
